import type { ReactElement } from "react";
import { getEditRecordUrl } from "../../utils";

interface LinkToRecordProps {
  recordId?: string;
  solutionId?: string;
  applicationId?: string;
}

export const LinkToRecord = ({
  recordId,
  solutionId,
  applicationId,
}: LinkToRecordProps): ReactElement => {
  if (recordId === undefined) {
    return <></>;
  }
  return (
    <a
      href={getEditRecordUrl(recordId, solutionId, applicationId)}
      target="_blank"
      rel="noreferrer"
    >
      {recordId}
    </a>
  );
};
